import { helper } from '@ember/component/helper';

import { timeDay } from 'd3-time';

export default helper(function scaleHasTimeFnHelper([ trueValue, falseValue ]) {
  return scale => scale && scale.ticks
  && scale.ticks().some(t => timeDay(t) < t)
    ? trueValue : falseValue;
});
